import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { compose } from 'redux';
import { connect } from 'react-redux';

import { useInjectReducer } from 'utils/injectReducer';
import { useInjectSaga } from 'utils/injectSaga';

import saga from './saga';
import reducer from './reducer';

export function MenuPreview({ children }) {
  useInjectSaga({ key: 'menuPreview', saga });
  useInjectReducer({ key: 'menuPreview', reducer });

  return React.Children.only(children);
}

MenuPreview.propTypes = {
  children: PropTypes.element,
};

const withConnect = connect();

export { default as withMenuPreview } from './withMenuPreview';
export default compose(withConnect, memo)(MenuPreview);
